import {Component} from '@angular/core';
import {LayoutService} from '../../layout.service';

declare var $: any;

@Component({
  selector: 'sa-collapse-menu',
  templateUrl: './collapse-menu.component.html'
})
export class CollapseMenuComponent {
  datai18n:any
  title : string;
  constructor(
    private layoutService: LayoutService
  ) {

    this.datai18n = JSON.parse(localStorage.getItem('datai18n'));
    this.title = this.datai18n['Header.collapseMenu'];
  
  }

  onToggle() {
    this.layoutService.onCollapseMenu()
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/collapse-menu/collapse-menu.component.ts